import { TextField } from '@mui/material'
import React , {  useCallback, useEffect } from 'react'

const NumberAndFloatFormField = React.memo(({
    value,
    label,
    name,
    onHandleChange,
    width=false,
    type='',
    className='',
}) => {

    const [localValue, setLocalValue] = React.useState(value);
    const [initialValue, setInitialValue] = React.useState(value);

    useEffect(() => {
        setLocalValue(value);
    },[value]);
    
    const handleChange = useCallback((event) => {
        setLocalValue(event.target.value);
    }, []);

    const handleFocus = () => {
        setInitialValue(localValue);
    }

    const handleBlur = () => {
        if(localValue !== initialValue){
            onHandleChange(name,localValue);
        }
    }

    const keyDownChange = (e) => {
        if(e.key === '+') {
            e.preventDefault();
        }
        if(type === "int" && e.key === '.'){
            e.preventDefault();
        } 
    }

    return (
        <TextField
            sx={{ 
                width: { 
                    xs: '100%', 
                    sm:width === false ? '30%':'100%',  
                    md:width === false ? '24%':'100%' 
                } 
            }}   
            className={className}
            margin="dense"
            label={label}
            key={name}
            name={name}
            value={localValue}
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            onKeyDown={keyDownChange}
            InputLabelProps={{
                shrink: true,
            }}
            InputProps={{
                inputProps: {
                    type: 'number',
                    //min: min, max: max,
                },
            }}
        />
    )
});

export default NumberAndFloatFormField